// Behavior-level. No table names, dedup internals, bundle_dimension config
// detail, or scheduler mechanics.

export default {
  title: 'Discrepancy Monitor',
  summary:
    'Stand up ongoing discrepancy monitors — upload or auto-fetch daily numbers, track the gap over time, drill into per-advertiser and per-bundle differences, and share a read-only view.',

  sections: [
    {
      h: 'What this tool does',
      p: [
        'Turns the one-off discrepancy check into a persistent monitor: each monitor holds your reports over time and tracks the gap day over day.',
        'It can pull numbers automatically from a partner API on a schedule, or take daily file uploads (deduplicated on the way in). You can drill down per advertiser and per bundle to see which line items or apps drive a given day\u2019s discrepancy, and generate a read-only share link so someone outside the dashboard can view the results without logging in.',
      ],
    },
    {
      h: 'When to use it',
      list: [
        'A discrepancy is recurring and you want to watch it over time instead of re-running a manual check.',
        'You need to show a partner the trend, or hand a stakeholder a view without giving them an account.',
      ],
    },
    {
      h: 'How to use it',
      steps: [
        '**Create a monitor** and name the parties.',
        '**Feed it data** — upload daily, or set it to fetch from a partner API automatically.',
        '**Watch the trend**, and open a day to break it down by advertiser or bundle.',
        '**Share** a read-only link if someone outside needs to see it.',
      ],
    },
    {
      callout:
        "Uploads are deduplicated as they come in, so re-uploading an overlapping date range won't double-count — it means the monitor keeps the most recent upload for a given row.",
    },
  ],

  faqs: [
    {
      q: 'Auto-fetch vs upload?',
      a: 'Auto-fetch pulls from a configured partner API on a schedule; upload is manual files. You can use either, per monitor.',
    },
    {
      q: 'Who can see a shared monitor?',
      a: "Anyone with the link — it's a public, read-only view with no login. Share it deliberately.",
    },
  ],
};
